export default function getSocketHost(url) {
  var _regex$exec;
  // get the host domain
  var regex = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i;
  var host = (_regex$exec = regex.exec(url)) == null ? void 0 : _regex$exec[1];
  var socketProtocol = /^http:\/\//i.test(url) ? 'ws' : 'wss';
  return "".concat(socketProtocol, "://").concat(host);
}